import React from 'react'
import Status from './Status'
import { HeadingWithIcon } from '../../../../../Components/Utils/Settingheading'
import { CalendarPlus } from 'lucide-react'

function IndexRenewals() {
  return (<>
           <HeadingWithIcon icon={CalendarPlus} title="Renewals" />

        <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
        <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
            <Status/>
         </div>
         </div></>
  )
}

export default IndexRenewals